module.exports = __webpack_public_path__ + "images/icons_v2/promotions-7cd45705.svg";